// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.join_btn_inner_div {
  width: 100%;
  height: 700px;
  position: relative;
  margin: 150px 0 0px 0;
}

.join_btn_img_div {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.join_btn_top_img {
  width: 100%;
  height: 100px;
  margin-top: -70px;
  position: absolute;
  z-index: 3;
}

.join_btn_main_img {
  width: 100%;
  height: 617px;
  object-fit: fill;
}

.join_btn_bottom_img {
  width: 100%;
  height: 100px;
  margin-bottom: 20px;
  position: absolute;
  z-index: 3;
  bottom: 0;
}

.join_btn_div {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.join_btn_div_p1 {
  color: #fff;
  font-family: "Open Sans";
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  text-transform: capitalize;
}

.join_btn_div_p2 {
  width: 80%;
  margin: 0 10% 33px 10%;
  padding: 20px 0 40px 0;
  color: #fff;
  font-family: "Open Sans";
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #206d23;
  text-align: center;
}

.join_btn_div_p3 {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  margin-bottom: 37px;
}

.join_btn_sub_div {
  width: 203px;
  height: 49px;
  position: relative;
  cursor: pointer;
}

.join_btn_sub_div > button {
  width: 203px;
  height: 46.378px;
  background: none;
  border: 1.4px solid #fff;
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 136.304%;
  cursor: pointer;
}









@media screen and (max-width: 1200px) {
 
  .join_btn_inner_div {
    width: 100%;
    height: 600px;
    margin: 100px 0 0 0;
  }
  
  .join_btn_img_div {
    flex-direction: column;
    justify-content: space-between;
  }
  
  .join_btn_top_img {
    width: 100%;
    height: 50px;
    margin-top: -20px;
  }
  
  .join_btn_main_img {
    height: 500px;
    object-fit: fill;
  }
  
  .join_btn_bottom_img {
    height: 50px;
    margin-bottom: 70px;
    bottom: 0;
  }
  
  .join_btn_div {
    height: 100%;
  }
  
  .join_btn_div_p1 {
    font-size: 36px;
  }
  
  .join_btn_div_p2 {
    width: 80%;
    margin: 0 10% 33px 10%;
    padding: 20px 0 30px 0;
    font-size: 36px;
    border-bottom: 2px solid #206d23;
  }
  
  .join_btn_div_p3 {
    font-size: 26px;
    margin-bottom: 30px;
  }
  
  .join_btn_sub_div {
    width: 203px;
    height: 49px;
  }
  
  .join_btn_sub_div > button {
    width: 203px;
    height: 46.378px;
    font-size: 20px;
  }

}












@media screen and (max-width: 1024px) {
 
  .join_btn_inner_div {
    width: 100%;
    height: 550px;
    margin: 70px 0 0 0;
  }
  
  .join_btn_img_div {
    flex-direction: column;
    justify-content: space-between;
  }
  
  .join_btn_top_img {
    width: 100%;
    height: 50px;
    margin-top: -20px;
  }
  
  .join_btn_main_img {
    height: 450px;
    object-fit: cover;
  }
  
  .join_btn_bottom_img {
    height: 50px;
    margin-bottom: 70px;
    bottom: 0;
  }
  
  .join_btn_div {
    height: 100%;
  }
  
  .join_btn_div_p1 {
    font-size: 36px;
  }
  
  .join_btn_div_p2 {
    width: 90%;
    margin: 0 5% 20px 5%;
    padding: 10px 0 20px 0;
    font-size: 36px;
    border-bottom: 2px solid #206d23;
  }
  
  .join_btn_div_p3 {
    font-size: 26px;
    margin-bottom: 30px;
  }
  
  .join_btn_sub_div {
    width: 180px;
    height: 46px;
  }
  
  .join_btn_sub_div > button {
    width: 180px;
    height: 46px;
    font-size: 18px;
  }

}














@media screen and (max-width: 800px) {
 
  .join_btn_inner_div {
    width: 100%;
    height: 450px;
    margin: 50px 0 0 0;
  }
  
  .join_btn_img_div {
    flex-direction: column;
    justify-content: space-between;
  }
  
  .join_btn_top_img {
    width: 100%;
    height: 50px;
    margin-top: -20px;
  }
  
  .join_btn_main_img {
    height: 350px;
    object-fit: cover;
  }
  
  .join_btn_bottom_img {
    height: 50px;
    margin-bottom: 70px;
    bottom: 0;
  }
  
  .join_btn_div {
    height: 100%;
  }
  
  .join_btn_div_p1 {
    font-size: 30px;
  }
  
  .join_btn_div_p2 {
    width: 90%;
    margin: 0 5% 20px 5%;
    padding: 10px 0 20px 0;
    font-size: 30px;
    border-bottom: 2px solid #206d23;
  }
  
  .join_btn_div_p3 {
    font-size: 22px;
    margin-bottom: 30px;
  }
  
  .join_btn_sub_div {
    width: 160px;
    height: 46px;
  }
  
  .join_btn_sub_div > button {
    width: 160px;
    height: 46px;
    font-size: 16px;
  }

}











@media screen and (max-width: 600px) {
 
  .join_btn_inner_div {
    width: 100%;
    height: 450px;
    margin: 50px 0 0 0;
  }
  
  .join_btn_img_div {
    flex-direction: column;
    justify-content: space-between;
  }
  
  .join_btn_top_img {
    width: 100%;
    height: 50px;
    margin-top: -40px;
  }
  
  .join_btn_main_img {
    height: 350px;
    object-fit: cover;
  }
  
  .join_btn_bottom_img {
    height: 50px;
    margin-bottom: 70px;
    bottom: 0;
  }
  
  .join_btn_div {
    height: 100%;
  }
  
  .join_btn_div_p1 {
    font-size: 24px;
  }
  
  .join_btn_div_p2 {
    width: 90%;
    margin: 0 5% 20px 5%;
    padding: 10px 0 20px 0;
    font-size: 24px;
    border-bottom: 2px solid #206d23;
  }
  
  .join_btn_div_p3 {
    font-size: 18px;
    margin-bottom: 10px;
    padding: 0 20px;
  }
  
  .join_btn_sub_div {
    width: 140px;
    height: 42px;
  }
  
  .join_btn_sub_div > button {
    width: 140px;
    height: 42px;
    font-size: 16px;
    margin-top: 15px;
  }

}













@media screen and (max-width: 450px) {
 
  .join_btn_inner_div {
    width: 100%;
    height: 450px;
    margin: 50px 0 0 0;
  }
  
  .join_btn_img_div {
    flex-direction: column;
    justify-content: space-between;
  }
  
  .join_btn_top_img {
    width: 100%;
    height: 50px;
    margin-top: -40px;
  }
  
  .join_btn_main_img {
    height: 350px;
    object-fit: cover;
  }
  
  .join_btn_bottom_img {
    height: 50px;
    margin-bottom: 70px;
    bottom: 0;
  }
  
  .join_btn_div {
    height: 100%;
  }
  
  .join_btn_div_p1 {
    font-size: 24px;
    line-height: 30px;
    margin-top: -80px;
    text-align: center;
  }
  
  .join_btn_div_p2 {
    width: 90%;
    margin: 0 5% 10px 5%;
    padding: 10px 0 10px 0;
    font-size: 22px;
    border-bottom: 2px solid #206d23;
  }
  
  .join_btn_div_p3 {
    font-size: 18px;
    margin-bottom: 10px;
    padding: 0 16px;
  }
  
  .join_btn_sub_div {
    width: 140px;
    height: 42px;
  }
  
  .join_btn_sub_div > button {
    width: 140px;
    height: 42px;
    font-size: 16px;
    margin-top: 10px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/homePage/joinBtn/joinBtn.css"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;;;;;;;;;AAUA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;;AAeA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEF;;;;;;;;;;;;AAYA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;AAEF;;;;;;;;;;;;;;AAcA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;AAEF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n\n.join_btn_inner_div {\n  width: 100%;\n  height: 700px;\n  position: relative;\n  margin: 150px 0 0px 0;\n}\n\n.join_btn_img_div {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.join_btn_top_img {\n  width: 100%;\n  height: 100px;\n  margin-top: -70px;\n  position: absolute;\n  z-index: 3;\n}\n\n.join_btn_main_img {\n  width: 100%;\n  height: 617px;\n  object-fit: fill;\n}\n\n.join_btn_bottom_img {\n  width: 100%;\n  height: 100px;\n  margin-bottom: 20px;\n  position: absolute;\n  z-index: 3;\n  bottom: 0;\n}\n\n.join_btn_div {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.join_btn_div_p1 {\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  text-transform: capitalize;\n}\n\n.join_btn_div_p2 {\n  width: 80%;\n  margin: 0 10% 33px 10%;\n  padding: 20px 0 40px 0;\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  text-transform: capitalize;\n  border-bottom: 2px solid #206d23;\n  text-align: center;\n}\n\n.join_btn_div_p3 {\n  color: #fff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: capitalize;\n  margin-bottom: 37px;\n}\n\n.join_btn_sub_div {\n  width: 203px;\n  height: 49px;\n  position: relative;\n  cursor: pointer;\n}\n\n.join_btn_sub_div > button {\n  width: 203px;\n  height: 46.378px;\n  background: none;\n  border: 1.4px solid #fff;\n  color: #fff;\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 136.304%;\n  cursor: pointer;\n}\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n \n  .join_btn_inner_div {\n    width: 100%;\n    height: 600px;\n    margin: 100px 0 0 0;\n  }\n  \n  .join_btn_img_div {\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .join_btn_top_img {\n    width: 100%;\n    height: 50px;\n    margin-top: -20px;\n  }\n  \n  .join_btn_main_img {\n    height: 500px;\n    object-fit: fill;\n  }\n  \n  .join_btn_bottom_img {\n    height: 50px;\n    margin-bottom: 70px;\n    bottom: 0;\n  }\n  \n  .join_btn_div {\n    height: 100%;\n  }\n  \n  .join_btn_div_p1 {\n    font-size: 36px;\n  }\n  \n  .join_btn_div_p2 {\n    width: 80%;\n    margin: 0 10% 33px 10%;\n    padding: 20px 0 30px 0;\n    font-size: 36px;\n    border-bottom: 2px solid #206d23;\n  }\n  \n  .join_btn_div_p3 {\n    font-size: 26px;\n    margin-bottom: 30px;\n  }\n  \n  .join_btn_sub_div {\n    width: 203px;\n    height: 49px;\n  }\n  \n  .join_btn_sub_div > button {\n    width: 203px;\n    height: 46.378px;\n    font-size: 20px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n \n  .join_btn_inner_div {\n    width: 100%;\n    height: 550px;\n    margin: 70px 0 0 0;\n  }\n  \n  .join_btn_img_div {\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .join_btn_top_img {\n    width: 100%;\n    height: 50px;\n    margin-top: -20px;\n  }\n  \n  .join_btn_main_img {\n    height: 450px;\n    object-fit: cover;\n  }\n  \n  .join_btn_bottom_img {\n    height: 50px;\n    margin-bottom: 70px;\n    bottom: 0;\n  }\n  \n  .join_btn_div {\n    height: 100%;\n  }\n  \n  .join_btn_div_p1 {\n    font-size: 36px;\n  }\n  \n  .join_btn_div_p2 {\n    width: 90%;\n    margin: 0 5% 20px 5%;\n    padding: 10px 0 20px 0;\n    font-size: 36px;\n    border-bottom: 2px solid #206d23;\n  }\n  \n  .join_btn_div_p3 {\n    font-size: 26px;\n    margin-bottom: 30px;\n  }\n  \n  .join_btn_sub_div {\n    width: 180px;\n    height: 46px;\n  }\n  \n  .join_btn_sub_div > button {\n    width: 180px;\n    height: 46px;\n    font-size: 18px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n \n  .join_btn_inner_div {\n    width: 100%;\n    height: 450px;\n    margin: 50px 0 0 0;\n  }\n  \n  .join_btn_img_div {\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .join_btn_top_img {\n    width: 100%;\n    height: 50px;\n    margin-top: -20px;\n  }\n  \n  .join_btn_main_img {\n    height: 350px;\n    object-fit: cover;\n  }\n  \n  .join_btn_bottom_img {\n    height: 50px;\n    margin-bottom: 70px;\n    bottom: 0;\n  }\n  \n  .join_btn_div {\n    height: 100%;\n  }\n  \n  .join_btn_div_p1 {\n    font-size: 30px;\n  }\n  \n  .join_btn_div_p2 {\n    width: 90%;\n    margin: 0 5% 20px 5%;\n    padding: 10px 0 20px 0;\n    font-size: 30px;\n    border-bottom: 2px solid #206d23;\n  }\n  \n  .join_btn_div_p3 {\n    font-size: 22px;\n    margin-bottom: 30px;\n  }\n  \n  .join_btn_sub_div {\n    width: 160px;\n    height: 46px;\n  }\n  \n  .join_btn_sub_div > button {\n    width: 160px;\n    height: 46px;\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n \n  .join_btn_inner_div {\n    width: 100%;\n    height: 450px;\n    margin: 50px 0 0 0;\n  }\n  \n  .join_btn_img_div {\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .join_btn_top_img {\n    width: 100%;\n    height: 50px;\n    margin-top: -40px;\n  }\n  \n  .join_btn_main_img {\n    height: 350px;\n    object-fit: cover;\n  }\n  \n  .join_btn_bottom_img {\n    height: 50px;\n    margin-bottom: 70px;\n    bottom: 0;\n  }\n  \n  .join_btn_div {\n    height: 100%;\n  }\n  \n  .join_btn_div_p1 {\n    font-size: 24px;\n  }\n  \n  .join_btn_div_p2 {\n    width: 90%;\n    margin: 0 5% 20px 5%;\n    padding: 10px 0 20px 0;\n    font-size: 24px;\n    border-bottom: 2px solid #206d23;\n  }\n  \n  .join_btn_div_p3 {\n    font-size: 18px;\n    margin-bottom: 10px;\n    padding: 0 20px;\n  }\n  \n  .join_btn_sub_div {\n    width: 140px;\n    height: 42px;\n  }\n  \n  .join_btn_sub_div > button {\n    width: 140px;\n    height: 42px;\n    font-size: 16px;\n    margin-top: 15px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n \n  .join_btn_inner_div {\n    width: 100%;\n    height: 450px;\n    margin: 50px 0 0 0;\n  }\n  \n  .join_btn_img_div {\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .join_btn_top_img {\n    width: 100%;\n    height: 50px;\n    margin-top: -40px;\n  }\n  \n  .join_btn_main_img {\n    height: 350px;\n    object-fit: cover;\n  }\n  \n  .join_btn_bottom_img {\n    height: 50px;\n    margin-bottom: 70px;\n    bottom: 0;\n  }\n  \n  .join_btn_div {\n    height: 100%;\n  }\n  \n  .join_btn_div_p1 {\n    font-size: 24px;\n    line-height: 30px;\n    margin-top: -80px;\n    text-align: center;\n  }\n  \n  .join_btn_div_p2 {\n    width: 90%;\n    margin: 0 5% 10px 5%;\n    padding: 10px 0 10px 0;\n    font-size: 22px;\n    border-bottom: 2px solid #206d23;\n  }\n  \n  .join_btn_div_p3 {\n    font-size: 18px;\n    margin-bottom: 10px;\n    padding: 0 16px;\n  }\n  \n  .join_btn_sub_div {\n    width: 140px;\n    height: 42px;\n  }\n  \n  .join_btn_sub_div > button {\n    width: 140px;\n    height: 42px;\n    font-size: 16px;\n    margin-top: 10px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
